/**
 * Flames Army — Wishlist
 * Paso 6: eventos a Klaviyo (versión enriquecida).
 *
 * Escucha los cambios de la wishlist y los manda a Klaviyo como eventos
 * personalizados. Debe cargarse DESPUÉS de wishlist.js y wishlist-ui.js.
 *
 * Klaviyo solo registra actividad de navegadores identificados. Si la
 * persona nunca hizo clic en un email ni se suscribió, el evento se
 * descarta — salvo que tengas activado el backfill de visitantes
 * anónimos, en cuyo caso queda guardado y se envía cuando se identifique.
 *
 * Los datos del producto (nombre, imagen, precio, tipo) los leemos de los
 * data-attributes del corazón y los guardamos en una caché propia en
 * localStorage. Así podemos mandar la wishlist completa aunque esos
 * productos no estén en la página actual.
 */

(function () {
  'use strict';

  if (!window.Wishlist) return;

  var EVENT_ADDED = 'Added to Wishlist';
  var EVENT_REMOVED = 'Removed from Wishlist';

  var META_KEY = 'fa:wishlist:meta';
  var MAX_ITEMS_IN_EVENT = 12;

  /* ------------------------------------------------------------------
   * Cola: klaviyo.js carga de forma asíncrona
   * ------------------------------------------------------------------ */

  var queue = [];
  var attempts = 0;
  var MAX_ATTEMPTS = 20; // ~10 segundos
  var timer = null;

  function klaviyoReady() {
    return window.klaviyo && typeof window.klaviyo.track === 'function';
  }

  function run(job) {
    try {
      var result =
        job.type === 'identify'
          ? window.klaviyo.identify(job.properties)
          : window.klaviyo.track(job.name, job.properties);

      if (result && typeof result.catch === 'function') {
        result.catch(function () {});
      }
    } catch (e) {
      // Un evento perdido no debe romper nada del sitio.
    }
  }

  function flush() {
    while (queue.length) {
      run(queue.shift());
    }
  }

  function enqueue(job) {
    if (klaviyoReady()) {
      run(job);
      return;
    }

    queue.push(job);
    waitForKlaviyo();
  }

  function track(name, properties) {
    enqueue({ type: 'track', name: name, properties: properties });
  }

  function identify(properties) {
    enqueue({ type: 'identify', properties: properties });
  }

  function waitForKlaviyo() {
    if (timer) return;

    timer = setInterval(function () {
      attempts++;

      if (klaviyoReady()) {
        clearInterval(timer);
        timer = null;
        flush();
        return;
      }

      if (attempts >= MAX_ATTEMPTS) {
        clearInterval(timer);
        timer = null;
        queue.length = 0;
      }
    }, 500);
  }

  /* ------------------------------------------------------------------
   * Caché de datos de producto
   * ------------------------------------------------------------------ */

  function readMeta() {
    try {
      return JSON.parse(window.localStorage.getItem(META_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function writeMeta(meta) {
    try {
      window.localStorage.setItem(META_KEY, JSON.stringify(meta));
    } catch (e) {
      // localStorage lleno o bloqueado: seguimos sin caché.
    }
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }

  function toNumber(value) {
    if (value === undefined || value === null || value === '') return null;
    var number = parseFloat(value);
    return isNaN(number) ? null : number;
  }

  function absoluteUrl(value) {
    if (!value) return null;
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.indexOf('/') === 0) return window.location.origin + value;
    return value;
  }

  function readButton(el) {
    if (!el || !el.getAttribute('data-wishlist-name')) return null;

    return {
      name: el.getAttribute('data-wishlist-name'),
      url: absoluteUrl(el.getAttribute('data-wishlist-url')),
      image: absoluteUrl(el.getAttribute('data-wishlist-image')),
      price: toNumber(el.getAttribute('data-wishlist-price')),
      priceFormatted: el.getAttribute('data-wishlist-price-formatted'),
      comparePrice: toNumber(el.getAttribute('data-wishlist-compare-price')),
      currency: el.getAttribute('data-wishlist-currency'),
      type: el.getAttribute('data-wishlist-type'),
      unavailable: el.getAttribute('data-wishlist-unavailable') === 'true',
      variants: parseJson(el.getAttribute('data-wishlist-variants'))
    };
  }

  // Guarda en caché todos los corazones presentes en la página.
  function scanPage() {
    var buttons = document.querySelectorAll('[data-wishlist-id][data-wishlist-name]');
    if (!buttons.length) return;

    var meta = readMeta();
    var changed = false;

    for (var i = 0; i < buttons.length; i++) {
      var id = buttons[i].getAttribute('data-wishlist-id');
      var data = readButton(buttons[i]);

      if (id && data) {
        meta[id] = data;
        changed = true;
      }
    }

    if (changed) writeMeta(prune(meta));
  }

  // Solo conservamos datos de lo que sigue en la wishlist.
  function prune(meta) {
    var items = window.Wishlist.get() || [];
    var keep = {};

    for (var i = 0; i < items.length; i++) {
      var id = String(items[i].id);
      if (meta[id]) keep[id] = meta[id];
    }

    return keep;
  }

  function getMeta(id) {
    // Lo que está en pantalla siempre gana: precios e imágenes cambian.
    var el = document.querySelector(
      '[data-wishlist-id="' + id + '"][data-wishlist-name]'
    );
    var fresh = readButton(el);

    if (fresh) {
      var meta = readMeta();
      meta[String(id)] = fresh;
      writeMeta(meta);
      return fresh;
    }

    return readMeta()[String(id)] || null;
  }

  function formatMoney(amount, currency) {
    if (amount === null || amount === undefined) return null;

    try {
      return new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: currency || 'COP',
        maximumFractionDigits: 0
      }).format(amount);
    } catch (e) {
      return String(amount);
    }
  }

  /* ------------------------------------------------------------------
   * Propiedades del evento
   * ------------------------------------------------------------------ */

  function buildProperties(item, count) {
    var properties = {
      ProductID: item.id,
      WishlistCount: count
    };

    if (item.variantId) properties.VariantID = item.variantId;

    if (item.handle) {
      properties.Handle = item.handle;
      properties.URL = window.location.origin + '/products/' + item.handle;
    }

    var meta = getMeta(item.id);
    if (!meta) return properties;

    if (meta.name) properties.ProductName = meta.name;
    if (meta.image) properties.ImageURL = meta.image;
    if (meta.url) properties.URL = meta.url;
    if (meta.type) properties.ProductType = meta.type;
    if (meta.currency) properties.Currency = meta.currency;
    if (meta.unavailable) properties.Available = false;

    var price = meta.price;
    var priceFormatted = meta.priceFormatted;

    // Si la persona tenía una talla seleccionada, mandamos ese precio.
    var variant = meta.variants && item.variantId
      ? meta.variants[String(item.variantId)]
      : null;

    if (variant) {
      if (variant.title) properties.VariantTitle = variant.title;

      if (typeof variant.price === 'number' && variant.price !== price) {
        price = variant.price;
        priceFormatted = formatMoney(price, meta.currency);
      }
    }

    if (price !== null && price !== undefined) {
      properties.Price = price;
      if (priceFormatted) properties.PriceFormatted = priceFormatted;
    }

    if (meta.comparePrice && price && meta.comparePrice > price) {
      properties.CompareAtPrice = meta.comparePrice;
      properties.OnSale = true;
    }

    return properties;
  }

  // La wishlist completa, para poder pintarla dentro del email.
  function buildItems() {
    var items = window.Wishlist.get() || [];
    var meta = readMeta();
    var list = [];

    for (var i = 0; i < items.length && list.length < MAX_ITEMS_IN_EVENT; i++) {
      var data = meta[String(items[i].id)];
      var entry = { ProductID: items[i].id };

      if (items[i].handle) {
        entry.Handle = items[i].handle;
        entry.URL = window.location.origin + '/products/' + items[i].handle;
      }

      if (data) {
        if (data.name) entry.ProductName = data.name;
        if (data.image) entry.ImageURL = data.image;
        if (data.url) entry.URL = data.url;
        if (data.price !== null) entry.Price = data.price;
        if (data.priceFormatted) entry.PriceFormatted = data.priceFormatted;
        if (data.type) entry.ProductType = data.type;
      }

      list.push(entry);
    }

    return list;
  }

  // Link a la wishlist completa: sirve para el botón del email.
  function buildWishlistUrl() {
    var handles = [];
    var items = window.Wishlist.get();

    for (var i = 0; i < items.length; i++) {
      if (items[i].handle) handles.push(items[i].handle);
    }

    if (handles.length === 0) return null;
    return window.location.origin + '/pages/wishlist?w=' + handles.join(',');
  }

  function unique(values) {
    var seen = {};
    var out = [];

    for (var i = 0; i < values.length; i++) {
      if (values[i] && !seen[values[i]]) {
        seen[values[i]] = true;
        out.push(values[i]);
      }
    }

    return out;
  }

  /* ------------------------------------------------------------------
   * Propiedades de perfil
   * ------------------------------------------------------------------
   * Esto solo aplica si el perfil ya está identificado. Sirve para armar
   * segmentos ("tiene wishlist", "le gustan los anillos") sin depender de
   * eventos, y para meter el link de su lista en cualquier campaña.
   */

  function updateProfile(count, wishlistUrl, items) {
    var types = [];
    var names = [];

    for (var i = 0; i < items.length; i++) {
      if (items[i].ProductType) types.push(items[i].ProductType);
      if (items[i].ProductName) names.push(items[i].ProductName);
    }

    identify({
      'Wishlist Count': count,
      'Wishlist URL': wishlistUrl,
      'Wishlist Updated At': new Date().toISOString(),
      'Wishlist Product Types': unique(types),
      'Wishlist Items': names
    });
  }

  /* ------------------------------------------------------------------
   * Escucha
   * ------------------------------------------------------------------ */

  document.addEventListener(window.Wishlist.EVENT, function (event) {
    var detail = event.detail || {};

    // 'sync' llega desde otra pestaña y 'merge' desde un link compartido:
    // ninguno es una acción deliberada de esta persona acá.
    if (detail.action !== 'add' && detail.action !== 'remove') return;
    if (!detail.item) return;

    var properties = buildProperties(detail.item, detail.count);
    var wishlistUrl = buildWishlistUrl();
    var items = buildItems();

    if (wishlistUrl) properties.WishlistURL = wishlistUrl;
    if (items.length) properties.Items = items;

    track(detail.action === 'add' ? EVENT_ADDED : EVENT_REMOVED, properties);
    updateProfile(detail.count, wishlistUrl, items);
  });

  /* ------------------------------------------------------------------
   * Arranque
   * ------------------------------------------------------------------ */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanPage);
  } else {
    scanPage();
  }

  // Las cards de /pages/wishlist llegan por Section Rendering API.
  setTimeout(scanPage, 1500);
})();